{
  "language": {
    "title": "Escolha seu idioma",
    "en": "Inglês",
    "nl": "Holandês",
    "sr": "Sérvio",
    "fr": "Francês",
    "de": "Alemão",
    "pt": "Português"
  },
  "home": {
    "welcomeMessage": "Olá, o que traz você aqui hoje?",
    "checkIn": "Check-in",
    "independentManualCheckIn": "Sem Agendamento",
    "integratedManualCheckIn": "Check-in manual",
    "checkOut": "Check-out",
    "manualCheckOut": "Check-out manual",
    "parcelDelivery": "Entrega de encomenda",
    "foodDelivery": "Entrega de comida",
    "callReception": "Ligar para a recepção",
    "overview": "Visão geral",
    "unavailable": "A recepção está indisponível no momento."
  },
  "check": {
    "option": {
      "checkin": {
        "title": "Escolha uma opção para fazer check-in",
        "manual": "Check-in manual",
        "code": "Check-in com código PIN/QR"
      },
      "checkout": {
        "title": "Escolha uma opção para fazer check-out",
        "manual": "Check-out com nome",
        "code": "Check-out com código PIN/QR"
      }
    },
    "title": "Aguardando para escanear seu código QR.<br/>Sem código QR? Sem problemas.",
    "orText": "OU",
    "qrScanner": {
      "checkin": {
        "title": "Escolha uma opção para fazer check-in"
      },
      "checkout": {
        "title": "Escolha uma opção para fazer check-out"
      },
      "btn": "Escaneie seu código QR"
    },
    "pinCode": "Digite seu código PIN",
    "manually": {
      "checkin": "Não tem credenciais?"
    },
    "status": {
      "idle": {
        "title": "Seu código está sendo escaneado.",
        "message": "Por favor, aguarde..."
      },
      "loading": {
        "title": "Seu código está sendo escaneado.",
        "message": "Por favor, aguarde..."
      },
      "error": {
        "title": "Seu código é inválido.",
        "message": "Por favor, tente novamente!"
      },
      "success": {
        "checkin": {
          "default": {
            "title": "Você fez check-in com sucesso.",
            "message": "Obrigado."
          },
          "MeetingAttendee": {
            "no-email-sms": {
              "title": "Você fez check-in com sucesso.",
              "message": "Obrigado."
            },
            "email-sms": {
              "title": "Você fez check-in com sucesso.",
              "message": "Seu contato foi notificado."
            },
            "call-ping": {
              "title": "Você fez check-in com sucesso.",
              "message": "Uma ligação será feita para o seu contato."
            }
          },
          "Employee": {
            "title": "Você fez check-in com sucesso.",
            "message": "Obrigado."
          },
          "Visitor": {
            "title": "Você fez check-in com sucesso.",
            "message": "Obrigado."
          }
        },
        "checkout": {
          "default": {
            "title": "Você fez check-out com sucesso.<br/>",
            "message": "Até a próxima."
          },
          "MeetingAttendee": {
            "title": "Você fez check-out com sucesso.",
            "message": "Até a próxima."
          },
          "Employee": {
            "title": "Você fez check-out com sucesso.",
            "message": "Até a próxima."
          },
          "Visitor": {
            "title": "Você fez check-out com sucesso.",
            "message": "Até a próxima."
          }
        }
      }
    }
  },
  "manualCheckin": {
    "title": "Por favor, preencha.",
    "subtitle": "Nota - Todos os campos * são obrigatórios",
    "noOption": "Sem opção",
    "btn": "Check-in",
    "placeholder": {
      "name": "Seu nome *",
      "email": "Seu e-mail *",
      "phone": "Número de celular",
      "contactName": "Nome do seu contato *"
    },
    "error": {
      "required": "Você não preencheu este campo",
      "name": "Nome inválido",
      "email": "Endereço de e-mail inválido",
      "phone": "Número de celular inválido"
    },
    "status": {
      "loading": {
        "title": "Por favor, aguarde...",
        "message": "Seu contato está sendo notificado."
      },
      "success": {
        "no-email-sms": {
          "title": "Você fez check-in com sucesso.",
          "message": "Obrigado."
        },
        "email-sms": {
          "title": "Você fez check-in com sucesso.",
          "message": "Seu contato foi notificado."
        },
        "call-ping": {
          "title": "Você fez check-in com sucesso.",
          "message": "Uma ligação será feita para o seu contato."
        }
      },
      "error": {
        "title": "Algo deu errado.",
        "message": "Por favor, tente novamente!"
      }
    }
  },
  "manualCheckout": {
    "title": "Digite seu nome para fazer check-out",
    "btn": "Check-out",
    "form": {
      "placeholder": {
        "name": "Seu nome completo *"
      },
      "loading": "Carregando...",
      "noOptions": "Sem opções"
    },
    "error": {
      "required": "Você não preencheu este campo",
      "name": "Nome inválido"
    },
    "status": {
      "loading": {
        "title": "Estamos escaneando suas informações.",
        "message": "Por favor, aguarde..."
      },
      "success": {
        "title": "Você fez check-out com sucesso.",
        "message": "Obrigado e tenha um bom dia."
      },
      "error": {
        "title": "Ocorreu um erro ao fazer check-out.",
        "message": "Por favor, tente novamente!"
      }
    }
  },
  "call": {
    "title": {
      "no-email-sms": "Deseja notificar seu contato?",
      "email-sms": "Enviamos um e-mail/SMS para seu contato.<br/>Deseja notificá-lo adicionalmente?"
    },
    "callBtn": "Ligar",
    "pingBtn": "Ping",
    "smsBtn": "SMS",
    "callVideoBtn": "Videochamada",
    "noBtn": "Cancelar",
    "cancelBtn": "Cancelar chamada",
    "status": {
      "connecting": {
        "title": "Estabelecendo chamada.<br/>Por favor, aguarde...",
        "message": ""
      },
      "ringing": {
        "title": "Chamando seu contato<br/>Por favor, aguarde...",
        "message": ""
      },
      "ringingReception": {
        "title": "Chamando a recepção.<br/>Por favor, aguarde...",
        "message": ""
      },
      "open": {
        "title": "Chamada em andamento.",
        "message": ""
      },
      "close": {
        "title": "Chamada encerrada.<br/>Por favor, aguarde seu contato.",
        "message": ""
      },
      "closeReception": {
        "title": "Chamada encerrada.",
        "message": ""
      },
      "error": {
        "title": "A chamada não foi estabelecida.<br/>Chamar novamente?",
        "message": ""
      }
    }
  },
  "message": {
    "status": {
      "idle": {
        "title": "Estamos notificando o contato.",
        "message": "Por favor, aguarde..."
      },
      "loading": {
        "title": "Estamos notificando o contato.",
        "message": "Por favor, aguarde..."
      },
      "success": {
        "title": "SMS enviado. O contato foi notificado.",
        "message": "Obrigado!"
      },
      "error": {
        "title": "SMS não enviado.",
        "message": "Por favor, tente novamente!"
      }
    }
  },
  "videoCall": {
    "title": "Videochamada",
    "endCall": "ENCERRAR CHAMADA",
    "status": {
      "idle": {
        "title": "Estamos criando uma sala de vídeo.",
        "message": "Por favor, aguarde..."
      },
      "loading": {
        "title": "Estamos criando uma sala de vídeo.",
        "message": "Por favor, aguarde..."
      },
      "success": {
        "title": "A sala de vídeo foi criada com sucesso.",
        "message": "Entrando na sala..."
      },
      "error": {
        "title": "A sala de vídeo não foi criada com sucesso.",
        "message": "Por favor, tente novamente!"
      }
    }
  },
  "packageDelivery": {
    "title": "Que bom que você trouxe uma encomenda!",
    "subtitle": "Selecione e notifique o destinatário",
    "subtitle1": "Pressione o botão abaixo para avisar que você chegou!",
    "subtitle2": "Você pode deixar o pacote na recepção.",
    "input": {
      "label": {
        "contact": "Para quem é a encomenda"
      },
      "error": {
        "contact": {
          "required": "Você não preencheu este campo"
        }
      }
    },
    "button": {
      "submit": "Notificar"
    },
    "status": {
      "loading": {
        "title": "Estamos notificando o contato.",
        "message": "Por favor, aguarde..."
      },
      "success": {
        "no-email-sms": {
          "title": "Obrigado pela entrega!",
          "message": ""
        },
        "email-sms": {
          "title": "O contato foi notificado.",
          "message": "Obrigado pela entrega!"
        },
        "call-ping": {
          "title": "Obrigado pela entrega!",
          "message": "Será feita uma conexão telefônica com o seu contato."
        }
      },
      "error": {
        "title": "Algo deu errado.",
        "message": "Por favor, tente novamente!"
      }
    }
  },
  "foodDelivery": {
    "title": "Que bom que você trouxe uma entrega de comida!",
    "subtitle": "Selecione e notifique o destinatário",
    "subtitle1": "Pressione o botão abaixo para avisar que você chegou!",
    "subtitle2": "Você pode deixar a comida na recepção.",
    "input": {
      "label": {
        "contact": "Para quem é a comida"
      },
      "error": {
        "contact": {
          "required": "Você não preencheu este campo"
        }
      }
    },
    "button": {
      "submit": "Notificar"
    },
    "status": {
      "loading": {
        "title": "Estamos notificando o contato.",
        "message": "Por favor, aguarde!"
      },
      "success": {
        "no-email-sms": {
          "title": "Obrigado pela entrega!",
          "message": ""
        },
        "email-sms": {
          "title": "O contato foi notificado.",
          "message": "Obrigado pela entrega!"
        },
        "call-ping": {
          "title": "Obrigado pela entrega!",
          "message": "Será feita uma conexão telefônica com o seu contato."
        }
      },
      "error": {
        "title": "Algo deu errado.",
        "message": "Por favor, tente novamente!"
      }
    }
  },
  "QRCodeScanner": {
    "title": "Por favor, escaneie seu código QR",
    "subtitle": "Alinhe o código QR dentro dos cantos vermelhos e mantenha o celular firme."
  },
  "common": {
    "backBtn": "Voltar"
  },
  "previewPDF": {
    "page": {
      "of": "de",
      "previous": "Anterior",
      "next": "Próximo"
    },
    "button": {
      "cancel": "Cancelar",
      "accept": "Aceitar",
      "next": "Próximo"
    },
    "title": {
      "consent": "Consentimento necessário"
    }
  },
  "offline": {
    "title": "Offline",
    "receptionMessage": "A recepção está offline no momento e não pode ser usada, a conexão de internet deve ser verificada!",
    "check": "Você é um visitante e deseja falar diretamente com um funcionário? Por favor, ligue para {{receptionistPhone}}"
  },
  "overview": {
    "title": "Digite o código para abrir a visão geral!",
    "noUsers": "Nenhum usuário",
    "status": {
      "success": {
        "title": "O código é válido.",
        "message": ""
      },
      "error": {
        "title": "O código não é válido.",
        "message": "Por favor, tente novamente!"
      }
    },
    "checkoutStatus": {
      "loading": {
        "title": "Por favor, aguarde...",
        "message": ""
      },
      "success": {
        "title": "Check-out bem-sucedido.",
        "message": ""
      },
      "error": {
        "title": "Algo deu errado.",
        "message": "Por favor, tente novamente!"
      }
    },
    "listTitle": "Lista de pessoas que fizeram check-in hoje, mas não fizeram check-out",
    "page": "Página ",
    "table": {
      "head": {
        "fullName": "Nome",
        "type": "Tipo",
        "checkedinAt": "Check-in às",
        "host": "Anfitrião"
      },
      "type": {
        "Package": "Entrega de pacote",
        "Food": "Entrega de comida",
        "Visitor": "Visitante",
        "MeetingAttendee": "Visitante convidado",
        "Employee": "Funcionário",
        "Guest": "Hóspede"
      }
    },
    "confirmModal": {
      "title": "Tem certeza de que deseja fazer o check-out de {{fullName}}?",
      "cancel": "Cancelar",
      "checkout": "Check-out"
    }
  },
  "wifi": {
    "title": "Conecte-se à rede Wi-Fi"
  }
}
